import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './HtmlEditor.css';
import EditorToolbar, { formats, modules } from './HtmlEditorToolbar';

interface EditorProps {
	value: string;
	onChange: (value: string) => void;
	onBlur: () => void;
	placeholder?: string;
	disabled?: boolean;
}

export const Editor: FC<EditorProps> = ({
	value,
	onChange,
	onBlur,
	placeholder,
	disabled = false,
}) => {
	const { t } = useTranslation();
	const quillRef = useRef<ReactQuill>(null);

	// Reset the editor content when value is empty
	useEffect(() => {
		if (value === '' && quillRef.current) {
			const editor = quillRef.current.getEditor();
			editor.setText('');
		}
	}, [value]);

	const handleChange = (content: string, delta: any, source: any, editor: any) => {
		let htmlContent = editor.getHTML();
		const isEmptyContent = (html: string) => {
			const textOnly = html.replace(/<(.|\n)*?>/g, '').trim();

			const emptyPatterns = ['<p><br></p>', '<p></p>', '<div><br></div>', '<div></div>'];

			return textOnly === '' || emptyPatterns.includes(html);
		};

		if (isEmptyContent(htmlContent)) {
			htmlContent = '';
		}

		onChange(htmlContent);
	};

	return (
		<div className="text-editor">
			<EditorToolbar />
			<ReactQuill
				readOnly={disabled}
				ref={quillRef}
				theme="snow"
				value={value}
				onChange={handleChange}
				onBlur={onBlur}
				placeholder={placeholder || t('htmlEditorText')}
				modules={modules}
				formats={formats}
			/>
		</div>
	);
};
